import * as React from "react";
import { type LucideIcon } from "lucide-react";

import {
    SidebarGroup,
    SidebarGroupContent,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from "@/components/ui/sidebar";
import { UserDataDto } from "@exibra/shared";
import { useUserData } from "@/api/user.api";
import { useTenantStore } from "@/store/tenant/tenant.store";
import isNil from "lodash.isnil";
import { useNavigate } from "react-router";

export function NavSecondary({
    items,
    ...props
}: {
    items: {
        title: string;
        url: string;
        icon: LucideIcon;
        enabled: (userData: UserDataDto, tenantId: number) => boolean;
    }[];
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
    const { data: userData } = useUserData();
    const selectedTenant = useTenantStore((state) => state.selectedTenant);
    const navigate = useNavigate();

    if (isNil(userData) || isNil(selectedTenant)) {
        return null;
    }

    const enabledItems = items.filter((item) => item.enabled(userData.data, selectedTenant.id));

    return (
        <SidebarGroup {...props}>
            <SidebarGroupContent>
                <SidebarMenu>
                    {enabledItems.map((item) => (
                        <SidebarMenuItem key={item.title}>
                            <SidebarMenuButton asChild tooltip={item.title}>
                                <button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(item.url);
                                    }}
                                >
                                    <item.icon />
                                    <span>{item.title}</span>
                                </button>
                            </SidebarMenuButton>
                        </SidebarMenuItem>
                    ))}
                </SidebarMenu>
            </SidebarGroupContent>
        </SidebarGroup>
    );
}
